export default __webpack_public_path__ + "static/media/astra-otoparts.5ba04ca8.svg";